import { useCookie } from "@/composable/useCookie";

const publicRoutes = ['/auth/login', '/auth/forgot-password', '/set-password'];

export default defineNuxtRouteMiddleware((to, from) => {
    if (process.client) {
        const { getCookie } = useCookie()
        const accessToken = getCookie("accessToken")

        const isPublicPage = publicRoutes.includes(to.path);
        const hasAccess = !!accessToken;

        if (!hasAccess && !isPublicPage) {
            return navigateTo('/auth/login')
        }
        if (hasAccess && isPublicPage) {
            return navigateTo('/');
        }
    }
})